import { ChannelConfiguration } from 'api/notifications';
import { ProjectFinancialsContractType } from 'api/project';

export interface ThresholdConfig {
  thresholdId: number;
  thresholdValue: number;
  notifyProjectOwners: boolean;
  notifyProjectMembers: boolean;
  notifyUsers: number[];
}

export interface UpdateFinancialAlertPayload {
  accountNotificationConfigurationMeta: {
    projectThresholdNotificationConditions: ThresholdConfig[];
  };
}

export enum FinancialNotificationEventType {
  ProjectBudgetThresholdReached = 'ProjectBudgetThresholdReached',
  ProjectHoursThresholdReached = 'ProjectHoursThresholdReached',
}

export interface FinancialNotificationConfig {
  accountId: number;
  accountNotificationConfigId: number;
  channels: ChannelConfiguration;
  createdAt: string;
  eventType: FinancialNotificationEventType;
  updatedAt: string;
  updatedBy: number;
  accountNotificationConfigurationMeta?: {
    projectThresholdNotificationConditions: ThresholdConfig[];
  };
}

export enum FixedFeeRevenueRecognitionProjectLevelTypes {
  AllProjects = 'ALL_PROJECT',
  ProjectLevel = 'PROJECT_LEVEL',
}

export enum FixedFeeRevenueRecognitionTypes {
  TrackedHoursByProjectHours = 'TRACKED_HOURS_BY_PROJECT_HOURS',
  TrackedHoursByAllocatedHours = 'TRACKED_HOURS_BY_ALLOCATED_HOURS',
  TrackedHoursByEstimateAtCompletion = 'TRACKED_HOURS_BY_ESTIMATE_AT_COMPLETION',
  MilestoneBased = 'MILESTONE_BASED',
  Manual = 'MANUAL',
}

export enum SubscriptionRevenueRecognitionTypes {
  EndOfPeriod = 'RECOGNISE_AT_END_OF_THE_PERIOD',
  TrackedHoursByPeriodHours = 'TRACKED_HOURS_BY_PERIOD_HOURS',
  TrackedHoursByPeriodAllocatedHours = 'TRACKED_HOURS_BY_PERIOD_ALLOCATED_HOURS',
}

export interface RevenueRecognitionConfigApi {
  accountId: number;
  financialContractType: ProjectFinancialsContractType;
  revenueRecognitionConfigId: number;
  revenueRecognitionType:
    | FixedFeeRevenueRecognitionTypes
    | SubscriptionRevenueRecognitionTypes;
  updatedAt: string;
  allowUsersToSetRevRecAtProjectLevel: boolean;
  allowedRevenueRecognitionTypes: Record<
    FixedFeeRevenueRecognitionTypes | SubscriptionRevenueRecognitionTypes,
    boolean
  >;
}

export type RevenueRecognitionConfig = Record<
  ProjectFinancialsContractType,
  RevenueRecognitionConfigApi
>;
